// extracted by css-extract-rspack-plugin
export default {"dot":"dot-R2ugxp","divider":"divider-UkGlrC","truncation":"truncation-wRXv9B"};